import Vue from 'vue';
import Vuex from 'vuex';

import { snackbar } from './snackbar';
import {account} from '@/_store/account';
import { api } from '@/_store/api';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        snackbar,
        account,
        api,
    },
});
